import axios from 'axios';
import {
    BASE_URL,
    GET_INVOICE_DETAIL_LINES_URL,
    GET_INVOICE_DETAIL_URL,
    GET_INVOICES_FOR_TODAY_URL,
    LOGIN_URL,
    SAVE_PICKUP_DETAIL_URL,
    SEARCH_CUSTOMERS_BY_CODE_URL,
    SEARCH_CUSTOMERS_BY_NAME_URL,
    SEARCH_INVOICE_BY_CUSTOMER_CODE,
    SEARCH_INVOICE_BY_CUSTOMER_NAME,
    SEARCH_INVOICE_BY_INVOICE_NUMBER_URL,
    REFRESH_TOKEN_URL,
    LOGOUT_USER_URL,
    SEARCH_CUSTOMER_ORDER_NUMBER_URL,
    SEARCH_INVOICE_BY_CUSTOMER_ORDER_NUMBER, GET_INVOICES_SETTING_URL
} from "../helpers/UrlHelper";
import { logoutUser} from "./login/AuthViewActions";
import history from "../history/History";
import {USER_KEY} from "../helpers/TokenHelper";



const apiClient = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json'
    }
})

export function setupInterceptors(store) {
    apiClient.interceptors.request.use((config) => {
            let user = JSON.parse(localStorage.getItem(USER_KEY));
            if (user) {
                config.headers["Authorization"] = `Bearer ${user.token}`;
            }

            return config;
        },
        (error) => {
            Promise.reject(error).then();
        })

    apiClient.interceptors.response.use((response) => {
            return response;
        }, function (error) {
            if(!error.response){
                //Check error has any response or not
                return Promise.reject(error);
            }
            // let user = JSON.parse(localStorage.getItem(USER_KEY));
            // if (user) {
            //     if (
            //         user.refreshToken &&
            //         error.response.status === 401 &&
            //         !originalRequest._retry
            //     ) {
            //         originalRequest._retry = true;
            //         return axios
            //             .post(FULLY_QUALIFIED_REFRESH_TOKEN_URL, getRefreshTokenObject(user.refreshToken))
            //             .then((res) => {
            //                 if (res.status === 200) {
            //
            //                     if (res.data.success) {
            //                         store.dispatch(loginRequestSuccess(res.data.data));
            //                         if (`Bearer ${res.data.data.token}`) {
            //                             originalRequest.headers["Authorization"] = `Bearer ${res.data.data.token}`;
            //                             return axios(originalRequest);
            //                         }
            //                     }
            //
            //                 }
            //             });
            //     }
            // }
            if (error.response.status === 401) {
                store.dispatch(logoutUser())
                history.push('/login');
            }

            if (error.response.status === 404) {
                history.push("/NotFound")
            }
            return Promise.reject(error);
        }
    );
}

export function retrieveInvoiceSetting(){
    return apiClient.get(GET_INVOICES_SETTING_URL)
}

export function retrieveInvoicesForToday(type) {
    return apiClient.get(`${GET_INVOICES_FOR_TODAY_URL}${type}`)
}

export function searchInvoicesByInvoiceNumber(type, invoiceNumber) {
    return apiClient.get(`${SEARCH_INVOICE_BY_INVOICE_NUMBER_URL}?type=${type}&number=${invoiceNumber}`)
}


export function searchInvoicesByCustomerCode(type, startDate, endDate, customerCode) {
    return apiClient.get(`${SEARCH_INVOICE_BY_CUSTOMER_CODE}?type=${type}&startDate=${startDate}&endDate=${endDate}&customerCode=${customerCode}`)
}

export function searchInvoicesByCustomerName(type, startDate, endDate, customerCodeName) {
    return apiClient.get(`${SEARCH_INVOICE_BY_CUSTOMER_NAME}?type=${type}&startDate=${startDate}&endDate=${endDate}&customerName=${customerCodeName}`)
}

export function searchInvoicesByCustomerOrderNumber(type, customerOrderNumber) {
    return apiClient.get(`${SEARCH_INVOICE_BY_CUSTOMER_ORDER_NUMBER}?type=${type}&orderNumber=${customerOrderNumber}`)
}


export function getInvoiceDetail(source, invoiceNumber) {
    return apiClient.get(GET_INVOICE_DETAIL_URL + source + "/" + invoiceNumber);
}

export function getInvoiceDetailLines(source, invoiceNumber) {
    return apiClient.get(GET_INVOICE_DETAIL_LINES_URL + source + "/" + invoiceNumber);
}

export function savePickupDetails(data) {
    return apiClient.post(SAVE_PICKUP_DETAIL_URL, data)
}

export function searchCustomersByCode(searchKey) {
    return apiClient.get(`${SEARCH_CUSTOMERS_BY_CODE_URL}${searchKey}`)
}


export function searchCustomersByName(searchKey) {
    return apiClient.get(`${SEARCH_CUSTOMERS_BY_NAME_URL}${searchKey}`)
}

export function loginUser(data) {
    return apiClient.post(LOGIN_URL, data)
}

export function refreshToken(token) {
    return apiClient.post(REFRESH_TOKEN_URL, getRefreshTokenObject(token))
}

export function logoutUserFromServer() {
    return apiClient.post(LOGOUT_USER_URL);
}

const getRefreshTokenObject = (token) => ({
    token,
    source: 'NexusPickup'
})

export function searchCustomerOrderNumber(type,searchKey) {
    return apiClient.get(`${SEARCH_CUSTOMER_ORDER_NUMBER_URL}${type}?searchKey=${searchKey}`)
}



